<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6 v-if="video">
          <v-row
            align="center"
            justify="space-around"
          >
            <v-btn
              depressed
              color="primary"
              :disabled="video.sort === 1 || size === 1"
              @click="goToPrev()"
            >
              Anterior
            </v-btn>
            <v-btn
              depressed
              color="primary"
              :disabled="last === video.sort"
              @click="goToNext()"
            >
              Próximo
            </v-btn>
          </v-row>
          <v-card
            v-if="video"
            max-width="700"
            class="mx-auto my-12"
          >
            <template slot="progress">
              <v-progress-linear
                color="deep-purple"
                height="10"
                indeterminate
              ></v-progress-linear>
            </template>

            <v-responsive :aspect-ratio="16/9">
              <youtube :video-id="videoId" ref="youtube"></youtube>
            </v-responsive>
            <v-card-title>
              {{video.title}}
            </v-card-title>

            <v-card-subtitle>
              {{video.description}}
            </v-card-subtitle>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import VideoService from '@/services/video/video'
import ModuleService from '@/services/module/module'

export default {
  name: 'Videos',
  data: () => ({
    video: {},
    videos: [],
    size: 0,
    videoId: '',
    loading: false,
    last: 0,
    VideoService: new VideoService(),
    ModuleService: new ModuleService()
  }),
  mounted () {
    this.loadVideo()
  },
  methods: {
    async loadVideosByModule (moduleId) {
      try {
        const { data } = await this.ModuleService.get(moduleId)
        this.videos = data.videos.sort((a, b) => a.sort - b.sort)
        this.last = this.videos[data.videos.length - 1].sort
        this.size = this.videos.length
      } catch (error) {
        console.log(error)
      }
    },
    async loadVideo () {
      try {
        const { data } = await this.VideoService.get(this.$route.params.id)
        this.video = data
        await this.loadVideosByModule(data.module_id)
        this.getId(this.video.link)
      } catch (error) {
        console.log(error)
      }
    },
    goToPrev () {
      const selectVideo = this.videos.find(video => video.sort === this.video.sort - 1)
      this.$router.push(`${selectVideo.id}`)
      this.$router.go()
    },
    goToNext () {
      const selectVideo = this.videos.find(video => video.sort === this.video.sort + 1)
      this.$router.push(`${selectVideo.id}`)
      this.$router.go()
    },
    getId (url) {
      this.videoId = this.$youtube.getIdFromUrl(url)
    }
  }
}
</script>

<style lang="scss">
iframe {
  width: 100%;
  height: 360px;
}
</style>
